<div class="h-full flex flex-1 flex-col">
	<form
		#debtForm="ngForm"
		class="h-full max-h-full relative flex flex-col flex-1"
		(ngSubmit)="saveModal(debtForm)"
	>
		<div class="flex flex-row justify-between items-center mb-4">
			<p class="text-2xl font-bold">
				{{ editing ? 'Edit' : 'Add' }} a bill or debt
			</p>
			<div class="flex gap-3">
				<app-checkbox
					type="clear"
					label="Pay from trust account"
					[(ngModel)]="debt.payFromTrust"
					name="payFromTrust"
					[testHook]="testHooks.PayFromTrustAccountCheckbox"
				></app-checkbox>
				<div class="flex-col justify-between items-center">
					<app-checkbox
						*ngIf="fileType !== purchaseFileType"
						type="clear"
						label="Show as Undertaking given"
						[(ngModel)]="debt.undertaking"
						name="undertaking"
						[testHook]="testHooks.ShowAsUndertakingGivenCheckbox"
					></app-checkbox>
					<app-checkbox
						type="clear"
						*ngIf="debt.undertaking"
						label="Fulfilled"
						[(ngModel)]="debt.fulfilled"
						name="fulfilled"
						[testHook]="testHooks.FulfilledCheckbox"
					></app-checkbox>
				</div>
			</div>
		</div>
		<div class="flex gap-6 w-full">
			<div class="flex flex-col flex-1 gap-6">
				<app-container type="dark" [testHook]="testHooks.Container">
					<p class="mr-4 text-xl font-bold">Payer(s)</p>
					<div class="flex flex-row gap-5">
						<app-checkbox
							*ngFor="let client of clients; let i = index"
							label="{{ client | clientName }}"
							[(ngModel)]="payer[client.id]"
							(ngModelChange)="changed()"
							[name]="payer + i"
							type="clear"
							[testHook]="testHooks.ChangCheckbox"
						></app-checkbox>
					</div>
				</app-container>

				<app-container
					type="dark"
					title="Payee"
					[testHook]="testHooks.PayeeContainer"
				>
					<div class="flex flex-col">
						<div class="flex-1 flex justify-between">
							<app-input
								type="text"
								label="Name"
								name="name"
								class="mr-5"
								[(ngModel)]="debt.payee.name"
								(ngModelChange)="changed()"
								[required]="true"
								[submitted]="debtForm.submitted"
								[testHook]="testHooks.Name"
							></app-input>
							<app-input
								type="text"
								label="Item being paid"
								name="item"
								class="flex-1"
								[(ngModel)]="debt.item"
								(ngModelChange)="changed()"
								[required]="true"
								[submitted]="debtForm.submitted"
								[testHook]="testHooks.ItemBeingPaid"
							></app-input>
						</div>
						<app-input
							type="text"
							label="Title or description"
							name="description"
							[placeholder]="descriptionPlaceholder"
							[(ngModel)]="debt.payee.description"
							(ngModelChange)="changed()"
							class="mt-2"
							[testHook]="testHooks.TitleOrDescription"
						></app-input>
					</div>
					<app-container
						title="Contact"
						type="light"
						[collapsable]="true"
						[collapsed]="editing"
						[@openClose]
						class="mt-4"
						[testHook]="testHooks.ContactContainer"
					>
						<app-address
							[address]="debt.payee.address"
							[enableCountrySelect]="false"
							name="Address"
							(onAddressUpdate)="addressChanged($event)"
						>
						</app-address>

						<div class="flex mt-5">
							<app-input
								type="text"
								label="Cell phone"
								name="cell"
								class="mr-5"
								[(ngModel)]="debt.payee.phoneCell"
								(ngModelChange)="changed()"
								[testHook]="testHooks.CellPhone"
							></app-input>
							<app-input
								type="text"
								label="Email"
								name="email"
								[(ngModel)]="debt.payee.email"
								(ngModelChange)="changed()"
								[testHook]="testHooks.Email"
							></app-input>
						</div>
						<div class="flex mt-5">
							<app-input
								type="text"
								label="Work phone"
								name="work"
								class="mr-5"
								[(ngModel)]="debt.payee.phoneWork"
								(ngModelChange)="changed()"
								[testHook]="testHooks.WorkPhone"
							></app-input>
							<app-input
								type="text"
								label="Fax"
								name="fax"
								[(ngModel)]="debt.payee.fax"
								(ngModelChange)="changed()"
								[testHook]="testHooks.Fax"
							></app-input>
						</div>
					</app-container>
				</app-container>
			</div>

			<div class="flex flex-col gap-6 flex-1 justify-start">
				<app-container
					[titleTemplate]="detailsTitleTemplate"
					type="dark"
					[testHook]="testHooks.Container1"
				>
					<div class="flex flex-col w-full gap-3">
						<app-input
							*ngIf="!addPerDiem"
							type="cents"
							label="Amount of cheque enclosed"
							name="amount"
							[startIcon]="ICON.DOLLAR"
							[(ngModel)]="debt.amount"
							(ngModelChange)="changed()"
							[submitted]="debtForm.submitted"
							class="w-1/2 pr-2"
							[testHook]="testHooks.AmountOfChequeEnclosed"
						></app-input>
						<div *ngIf="addPerDiem" class="flex flex-col w-full gap-2">
							<div class="flex gap-5 justify-between">
								<app-date-picker
									label="Start date"
									name="startDate"
									[(ngModel)]="debt.startDate"
									(ngModelChange)="changed()"
									maxDate="{{ debt.endDate }}"
									maxDateErrorLabel="End date"
									[required]="true"
									[submitted]="debtForm.submitted"
									[testHook]="testHooks.StartDateDatePicker"
								></app-date-picker>
								<app-date-picker
									label="End date"
									name="endDate"
									[(ngModel)]="debt.endDate"
									(ngModelChange)="changed()"
									minDate="{{ debt.startDate }}"
									minDateErrorLabel="Start date"
									[required]="true"
									[submitted]="debtForm.submitted"
									[testHook]="testHooks.EndDateDatePicker"
								></app-date-picker>
							</div>
							<div class="flex gap-5 justify-between">
								<app-input
									type="cents"
									label="Principal amount"
									name="principalAmount"
									[startIcon]="ICON.DOLLAR"
									[(ngModel)]="debt.principalAmount"
									(ngModelChange)="changed()"
									[submitted]="debtForm.submitted"
									[testHook]="testHooks.PrincipalAmount"
								></app-input>
								<app-input
									type="cents"
									label="Per diem interest"
									name="perDiemInterest"
									[startIcon]="ICON.DOLLAR"
									[(ngModel)]="debt.perDiem"
									(ngModelChange)="changed()"
									[submitted]="debtForm.submitted"
									[testHook]="testHooks.PerDiemInterest"
								></app-input>
							</div>
						</div>
						<div
							class="flex gap-4 w-full justify-end items-center mt-2"
							*ngIf="addPerDiem"
						>
							<p>Total amount:</p>
							<p class="font-bold text-xl">
								{{ this.debt.amount || 0 | centsToDollars }}
							</p>
						</div>
						<hr *ngIf="addPerDiem" />
						<div class="flex gap-5 justify-between">
							<app-input
								type="text"
								label="Account number"
								name="price"
								[(ngModel)]="debt.account"
								(ngModelChange)="changed()"
								[testHook]="testHooks.AccountNumber"
							></app-input>
							<app-date-picker
								label="Follow up date"
								name="date"
								[(ngModel)]="debt.followUp"
								(ngModelChange)="changed()"
								[testHook]="testHooks.FollowUpDateDatePicker"
							></app-date-picker>
						</div>
					</div>
				</app-container>

				<app-container
					type="dark"
					title="Options"
					[testHook]="testHooks.OptionsContainer"
				>
					<div class="flex flex-col gap-3">
						<app-checkbox
							label="Request to close account"
							name="requestCloseAccount"
							[(ngModel)]="debt.options.close"
							(ngModelChange)="changed()"
							type="clear"
							[testHook]="testHooks.RequestToCloseAccountCheckbox"
						></app-checkbox>
						<app-checkbox
							label="Request payment receipt"
							name="requestPaymentReceipt"
							[(ngModel)]="debt.options.receipt"
							(ngModelChange)="changed()"
							type="clear"
							[testHook]="testHooks.RequestPaymentReceiptCheckbox"
						></app-checkbox>
						<app-checkbox
							label="Mention real estate transaction"
							name="realEstateTransaction"
							[(ngModel)]="debt.options.mention"
							(ngModelChange)="changed()"
							type="clear"
							[testHook]="testHooks.MentionRealEstateTransactionCheckbox"
						></app-checkbox>
					</div>
				</app-container>

				<app-container
					type="dark"
					title="Notes"
					[testHook]="testHooks.NotesContainer"
				>
					<app-text-area
						name="notes"
						[(ngModel)]="debt.notes"
						[testHook]="testHooks.NotesTextArea"
					></app-text-area>
				</app-container>
			</div>
		</div>

		<div class="flex justify-between mt-4">
			<app-button
				btn="border"
				(click)="cancelModal()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button type="submit" [testHook]="testHooks.SaveButton"
				>Save</app-button
			>
		</div>
	</form>

	<ng-template #detailsTitleTemplate>
		<div class="flex gap-5 pl-3 pt-3 items-center mb-3 justify-between">
			<p class="text-xl font-bold">Details</p>
			<app-checkbox
				type="clear"
				label="Apply per diem calculations"
				[ngModel]="addPerDiem"
				name="addPerDiem"
				(ngModelChange)="togglePerDiem()"
				[testHook]="testHooks.ApplyPerDiemCalculationsCheckbox"
			></app-checkbox>
		</div>
	</ng-template>
</div>
